/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PlanTier,
    PlanTierFromJSON,
    PlanTierFromJSONTyped,
    PlanTierToJSON,
    SubscriptionState,
    SubscriptionStateFromJSON,
    SubscriptionStateFromJSONTyped,
    SubscriptionStateToJSON,
} from './';

/**
 * 
 * @export
 * @interface InstallationSubscription
 */
export interface InstallationSubscription {
    /**
     * 
     * @type {SubscriptionState}
     * @memberof InstallationSubscription
     */
    state: SubscriptionState;
    /**
     * 
     * @type {PlanTier}
     * @memberof InstallationSubscription
     */
    planTier: PlanTier;
    /**
     * 
     * @type {number}
     * @memberof InstallationSubscription
     */
    repoLimit?: number;
    /**
     * 
     * @type {Date}
     * @memberof InstallationSubscription
     */
    currentPeriodEnd?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InstallationSubscription
     */
    cancelsAt?: Date;
}

export function InstallationSubscriptionFromJSON(json: any): InstallationSubscription {
    return InstallationSubscriptionFromJSONTyped(json, false);
}

export function InstallationSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstallationSubscription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'state': SubscriptionStateFromJSON(json['state']),
        'planTier': PlanTierFromJSON(json['planTier']),
        'repoLimit': !exists(json, 'repoLimit') ? undefined : json['repoLimit'],
        'currentPeriodEnd': !exists(json, 'currentPeriodEnd') ? undefined : (new Date(json['currentPeriodEnd'])),
        'cancelsAt': !exists(json, 'cancelsAt') ? undefined : (new Date(json['cancelsAt'])),
    };
}

export function InstallationSubscriptionToJSON(value?: InstallationSubscription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'state': SubscriptionStateToJSON(value.state),
        'planTier': PlanTierToJSON(value.planTier),
        'repoLimit': value.repoLimit,
        'currentPeriodEnd': value.currentPeriodEnd === undefined ? undefined : (value.currentPeriodEnd.toISOString()),
        'cancelsAt': value.cancelsAt === undefined ? undefined : (value.cancelsAt.toISOString()),
    };
}

